module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\"><path fill=\"currentColor\" d=\"M7.35 11.44c.4-.25.9-.25 1.3 0l2.91 1.79-.8-3.32c-.11-.46.05-.94.4-1.24l2.6-2.22-3.4-.26a1.25 1.25 0 0 1-1.06-.77L8 2.27 6.7 5.42c-.18.44-.59.74-1.06.77l-3.4.26 2.6 2.22c.35.3.51.78.4 1.24l-.8 3.32 2.9-1.79zM8 12.51l-2.9 1.78a1.25 1.25 0 0 1-1.88-1.35l.8-3.32-2.6-2.21a1.25 1.25 0 0 1 .72-2.2l3.4-.26 1.3-3.16a1.25 1.25 0 0 1 2.32 0l1.3 3.16 3.4.26a1.25 1.25 0 0 1 .71 2.2l-2.6 2.2.8 3.33a1.25 1.25 0 0 1-1.86 1.35L8 12.51z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icons/svg/icon-favourite-small.svg
// module id = 914
// module chunks = 0